import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { NavLink, useSearchParams } from "react-router-dom";

import PageHeading from "@/v2/components/ui/heading/Page";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";
import { Supplier } from "@/v2/types";
import {
    SuppliersColumn,
    SuppliersFilterColumn,
} from "@/v2/components/data-table/columns/Supplier";
import FindAllSupplier from "@/v2/api/supplier/FindAll";
import GenerateSupplierOnboardLink from "./GenerateLink";
import ExportSupplier from "@/v2/api/supplier/Export";
import AccessControl from "@/v2/components/rbac/AccessControl";

export default function SupplierPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["suppliers", skip, limit, search, filter],
        queryFn: () =>
            FindAllSupplier({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Supplier Database"
                    description="Manage and monitor all suppliers in your platform"
                />

                <AccessControl
                    module="SUPPLIER_MANAGEMENT"
                    requestedAccess={["POST"]}
                >
                    <div className="flex gap-4">
                        <GenerateSupplierOnboardLink />
                        <NavLink to={"create"}>
                            <Button>Add New Supplier</Button>
                        </NavLink>
                    </div>
                </AccessControl>
            </div>

            <Card className="p-2">
                <TableToolbar<Supplier>
                    column={SuppliersFilterColumn}
                    searchPlaceHolder="Search suppliers.."
                    exportFileName="suppliers"
                    exportFunc={() => ExportSupplier({ filter })}
                />

                <DataTable<Supplier>
                    data={query.data?.data || []}
                    columns={SuppliersColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
